var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"content_area"},[_c('div',{staticClass:"us"},[_c('h2',[_vm._v("联系我们")]),_c('div',{staticClass:"content"},[_c('div',[_vm._v("联系人：河北省国际货运代理协会秘书处")]),_c('div',[_vm._v("电话： 0311-87708676")]),_c('div',[_vm._v("Email： hebifa@hebifa.com")]),_c('div',[_vm._v("地址：石家庄市新华区泰华街29号天林大厦1512室")])])])])])
}]

export { render, staticRenderFns }